import apiClient from '../client';
import { CreateSalesOrderDTO, SalesOrder } from '@shared/types/Order';

export const salesOrderService = {
  createSalesOrder: async (data: CreateSalesOrderDTO): Promise<SalesOrder> => {
    const response = await apiClient.post('/sales-orders', data);
    return response.data;
  },

  getSalesOrderById: async (orderId: number): Promise<SalesOrder> => {
    const response = await apiClient.get(`/sales-orders/${orderId}`);
    return response.data;
  },

  lookupPart: async (partNumber: string, customerId?: string): Promise<{ PartNumber: string; Description: string; Price: number; LineItemIndex: number } | null> => {
    try {
      const params = new URLSearchParams({ partNumber });
      if (customerId) params.append('customerId', customerId);
      const response = await apiClient.get(`/sales-orders/part-lookup?${params}`);
      return response.data;
    } catch {
      return null;
    }
  },
};
